import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

// Teletel (owner decision, release audit 2026-08-15): this page fronts the
// independent Teletel SLA backend, so access depends on administrator or
// sla_manage authorization and the Teletel server runtime response (the page renders the
// fail-closed banner while disabled) — never on the SLA premium flag or the
// enterprise paywall.
const meta = {
  permissions: ['administrator', 'sla_manage'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/sla'),
      component: SettingsWrapper,
      props: {},
      children: [
        {
          path: '',
          name: 'sla_wrapper',
          meta,
          redirect: to => {
            return { name: 'sla_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'sla_list',
          meta,
          component: Index,
        },
      ],
    },
  ],
};
